import {
  Box,
  Input,
  Textarea,
  Button,
  Flex,
  Heading,
  Divider,
  useTheme,
  Tooltip,
  Icon,
  Text,
  IconButton,
} from '@chakra-ui/react';
import { DeleteIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import { useAutoResize } from '../../hooks/util';
import { useRef } from 'react';

const QuestionContext = ({
  name,
  description,
  context,
  handleDelete,
  handleNameChange,
  handleDescriptionChange,
  handleContextChange,
}) => {
  const contextRef = useRef(null);
  const theme = useTheme();
  useAutoResize(contextRef);

  return (
    <Box pb={10} my={4}>
      <Flex
        justifyContent='space-between'
        alignItems='center'
        borderBottom='1px'
        borderColor='black'
      >
        <Heading as='h3' size='md' ml={1} mb={3}>
          <Input
            value={name}
            onChange={handleNameChange}
            variant='unstyled'
            fontSize='18px'
            fontWeight='bold'
            _focus={{ outline: 'none' }}
          />
        </Heading>
        <IconButton
          mb={2}
          icon={<DeleteIcon />}
          onClick={handleDelete}
          aria-label='delete'
          color='red'
          _hover={{
            backgroundColor: theme.colors.red,
            color: 'white',
          }}
          _active={{
            backgroundColor: theme.colors.red,
            color: 'white',
          }}
        />
      </Flex>
      <Divider mb={3} />
      <Flex alignItems='center' mb={1}>
        <Text fontWeight={'bold'} mr={1}>
          Description
        </Text>
        <Tooltip label="Used by the bot to match the user's question to this context.">
          <InfoOutlineIcon boxSize={4} ml={1} opacity='.5' />
        </Tooltip>
      </Flex>
      <Input
        background={theme.colors.bgGrey2}
        placeholder='Description'
        value={description}
        onChange={handleDescriptionChange}
        mb={3}
      />
      <Flex alignItems='center' mb={1}>
        <Text fontWeight={'bold'} mr={1}>
          Context
        </Text>
        <Tooltip label="When the user's question matches this context, the following text will be added to all prompts that interact with the database.">
          <InfoOutlineIcon boxSize={4} ml={1} opacity='.5' />
        </Tooltip>
      </Flex>
      <Textarea
        ref={contextRef}
        background={theme.colors.bgGrey2}
        placeholder='Context'
        value={context}
        onChange={handleContextChange}
        resize='none'
        overflow='hidden'
        height='unset'
      />
    </Box>
  );
};

export default QuestionContext;
